import React from 'react';
import { Toolbar, SaveButton, DeleteButton, useRecordContext } from 'react-admin';
import { useFormState } from 'react-hook-form';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
	},
});

const PictureToolbar = ({ saving }) => {
	const record = useRecordContext();
	const classes = useStyles();
	const { isValid } = useFormState();

	const transform = data => {
		const data_ids = data.pictures.map(p => p.id);
		const delete_pictures_ids = record.pictures.map(p => p.id).filter(id => data_ids.indexOf(id) === -1);
		return { ...data, delete_pictures_ids };
	};

	return (
		<Toolbar className={classes.toolbar}>
			<SaveButton type="button" transform={transform} invalid={!isValid} saving={saving} />
			<DeleteButton mutationMode="pessimistic" />
		</Toolbar>
	);
};

export default PictureToolbar;